import gql from 'graphql-tag';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { SupervisorRetentionOfferHistoryItem } from '@/models/payment';

export const fetchSupervisorRetentionOfferHistory = async (
  phoneNumber: string,
): Promise<SupervisorRetentionOfferHistoryItem[]> => {
  const response = await queryExecute({
    query: gql`
      query SupervisorRetentionOfferHistory($phoneNumber: String!) {
        supervisorRetentionOfferHistory(phoneNumber: $phoneNumber) {
          id
          reason
          amount
          expirationType
          expirationValue
          expiresAt
          expiringCreditId
          plan
          notes
          createdAt
          userName
        }
      }
    `,
    variables: {
      phoneNumber,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data?.supervisorRetentionOfferHistory ?? [];
};
